import { render, staticRenderFns } from "./DisplayOverviewReport.vue?vue&type=template&id=5008333e&scoped=true"
import script from "./DisplayOverviewReport.vue?vue&type=script&lang=js"
export * from "./DisplayOverviewReport.vue?vue&type=script&lang=js"
import style0 from "./DisplayOverviewReport.vue?vue&type=style&index=0&id=5008333e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008333e",
  null
  
)

export default component.exports